import React from 'react'
import PropTypes from 'prop-types'
import { TierLabelWrapper } from './component.styles'

const TierLabel = ({ labelText, color, labelTextColor }) => {
  if (typeof labelText !== 'string') {
    console.warn(
      'labelText is not a string. Returning null from compenent. Labelt text is',
      labelText,
    )
    return null
  }

  return (
    <TierLabelWrapper color={color} labelTextColor={labelTextColor}>
      {labelText}
    </TierLabelWrapper>
  )
}

TierLabel.propTypes = {
  color: PropTypes.string,
  labelText: PropTypes.string.isRequired,
  labelTextColor: PropTypes.string,
}

export default TierLabel
